import { CardVariants } from '@anm/components/Card';
import CardModal from '@anm/components/modals/CardModal';
import isMobile from '@anm/helpers/is/isMobile';
import { memo, FC } from 'react';

import TemplateVideoWithControls from '../TemplateVideoWithControls';

import Wrapper, { CloseButtonOverrideStyles, VIEW_MAX_WIDTH } from './Wrapper';
import { useModelCloseHandler, useTrackEvents } from './hooks';

const cardSettings = {
  hasShadow: false,
  isPadding: false,
  variant: 'transparent' as CardVariants,
  minWidth: isMobile() ? 'unset' : `${VIEW_MAX_WIDTH}px`
};

const TemplateViewModal: FC = () => {
  useTrackEvents();
  const handleModalClose = useModelCloseHandler();

  return (
    <>
      <CloseButtonOverrideStyles />
      <CardModal isInnerModal onModalClose={handleModalClose} cardSettings={cardSettings}>
        <Wrapper>
          <TemplateVideoWithControls
            variant="gray"
            direction="column"
            orientation="horizontal"
            activeRatioItemColor="white"
            heightDependence="screen_dependence"
            withDescription
            onTemplateEdit={handleModalClose}
          />
        </Wrapper>
      </CardModal>
    </>
  );
};

export default memo(TemplateViewModal);
